import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard, CheckoutStepsSetGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { CustomIconsModule } from '../../../../../../../custom/icons/custom-icons.module';
import { CustomCheckoutAuthGuard } from "../../../guards/custom-checkout-auth.guard";
import { CustomCheckoutProgressMobileTopComponent } from './checkout-progress-mobile-top.component';

@NgModule({
  imports: [
    CommonModule,
    UrlModule,
    I18nModule,
    RouterModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutProgressMobileTop: {
          component: CustomCheckoutProgressMobileTopComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard, CheckoutStepsSetGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomCheckoutProgressMobileTopComponent],
  exports: [CustomCheckoutProgressMobileTopComponent]
})
export class CustomCheckoutProgressMobileTopModule { }
